import React from 'react';

interface Balance {
    nickname: string;
    paid: number;
    balance: number;
}

interface BalanceListProps {
    balances: Balance[];
}

export const BalanceList: React.FC<BalanceListProps> = ({ balances }) => {
    return (
        <div className="balance-section">
            <h3 className="section-title">👥 참여자별 정산</h3>
            <div className="balance-list">
                {balances.map((participant, index) => (
                    <div key={index} className="balance-item">
                        <div className="balance-participant">
                            <div className="participant-avatar">👤</div>
                            <div className="participant-name">{participant.nickname}</div>
                        </div>
                        <div className="balance-amounts">
                            <div className="balance-paid">
                                지불 {participant.paid.toLocaleString('ko-KR')}원
                            </div>
                            <div className={`balance-status ${participant.balance > 0 ? 'positive' : participant.balance < 0 ? 'negative' : 'zero'}`}>
                                {participant.balance > 0 ? `+${participant.balance.toLocaleString('ko-KR')}원` :
                                    participant.balance < 0 ? `${participant.balance.toLocaleString('ko-KR')}원` :
                                        '정산 완료'}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
